module.exports = __webpack_public_path__ + "static/img/hh-heard1.bb1077f5.png";